export const User = "User"
export const UserRole = "UserRole"
export const UserLocale = "UserLocale"
export const Update = "Update"
export const Customer = "Customer"
export const Bundle = "Bundle"
export const Loan = "Loan"
export const LoanDetails = "LoanDetails"
export const UploadCsv = "UploadCsv"
export const Batch = "Batch"
export const AgeSetting = "AgeSetting"
export const Organization = "Organization"
export const TandC = "TandC"
export const VerifCode = "VerifCode"
export const Send2FA = "Send2FA"
export const CustomerLoans = "CustomerLoans"
export const QRCode = "QRCode"
export const UpdateQRCode = "UpdateQRCode"
export const DevicesToOpen = "DevicesToOpen"
export const Business = "Business"
export const BusinessLoans = "BusinessLoans"
export const Charges = "Charges"
export const GLAccount = "GLAccount"
export const GLClosure = "GLClosure"
export const JournalEntry = "JournalEntry"
export const AccountingRule = "AccountingRule"
export const LoanCommission = "LoanCommission"
export const CommissionLog = "CommissionLog"
export const BundleFilter = "BundleFilter"
export const AffiliateFilter = "AffiliateFilter"
export const StatusFilter = "StatusFilter"
export const CreatedByFilter = "CreatedByFilter"
export const AssignToFilter = "AssignToFilter"
export const CollateralFilter = "CollateralFilter"
export const AffiliateCustomerFilter = "AffiliateCustomerFilter"
export const CollateralBundleFilter = "CollateralBundleFilter"
export const UserRoleFilter = "UserRoleFilter"
export const GLAccountNameFilter = "GLAccountNameFilter"
export const AccountToDebitsFilter = "AccountToDebitsFilter"
export const AccountToCreditsFilter = "AccountToCreditsFilter"
export const FinancierBatch = "FinancierBatch"
export const FinancierBucket = "FinancierBucket"
export const FinancierAffiliationFilter = "FinancierAffiliationFilter"
export const Investor = "Investor"
export const InvestorPayment = "InvestorPayment"



// WEBPACK FOOTER //
// ./src/redux/items/types.js